export const ONLY_DIGIT_REGEX = /\d/;

export const DIGIT_WITHOUT_ZERO_REGEX = /[1-9]/;
